import heic2any from "heic2any";

export const isHeicFile = (file) => {
  if (!file) return false;
  const type = (file.type || "").toLowerCase();
  const name = (file.name || "").toLowerCase();
  return (
    type === "image/heic" ||
    type === "image/heif" ||
    name.endsWith(".heic") ||
    name.endsWith(".heif")
  );
};

/**
 * Convert HEIC/HEIF to JPEG. Non-HEIC files are returned as-is.
 * Uses lower quality for faster conversion.
 */
export const convertHeicToJpeg = async (file) => {
  if (!isHeicFile(file)) return file;

  const converted = await heic2any({
    blob: file,
    toType: "image/jpeg",
    quality: 0.7,
  });

  const blob = Array.isArray(converted) ? converted[0] : converted;
  const jpegName = file.name.replace(/\.(heic|heif)$/i, ".jpg");

  return new File([blob], jpegName, {
    type: "image/jpeg",
    lastModified: file.lastModified,
  });
};
